import React, { FC } from 'react';
import { match } from 'ts-pattern';

import { CollectionCard } from '@catawiki/cata-style';

import { MockCollection } from '@/shared/stubs/collection';
import { CollectionInfo } from '@/shared/models/collection';

import { getCollectionCardImagesUrls } from './utils';
import { ScrollableList } from '../ScrollableList';
import styles from './Row.module.scss';

export interface CollectionInput {
  collectionId: number;
}

interface Props {
  collectionIds?: CollectionInput[];
  collections?: CollectionInfo[];
  locale: string;
}

export const Row: FC<Props> = ({ collectionIds = [], collections = [] }) => {
  const items = match({
    hasIds: collectionIds.length > 0,
    hasItems: collections.length > 0,
  })
    .with({ hasIds: true, hasItems: false }, () =>
      collectionIds.map((item) => MockCollection(item.collectionId))
    )
    .otherwise(() => collections);

  return (
    <ScrollableList
      data-testid="row"
      arrowClassName={styles.arrow}
      itemClassName={styles.item}
    >
      {items.map((collection) => {
        const { id, title, url, images, tags, color } = collection;
        const { portrait, landscape } = getCollectionCardImagesUrls(images);

        return (
          <CollectionCard
            key={`collection-card-${id}`}
            href={url}
            title={title}
            landscapeImages={landscape}
            portraitImages={portrait}
            numberOfLots={collection.lot_count}
            ctaText={collection.cta_text ?? ''}
            tags={tags ?? ''}
            color={color ?? ''}
          />
        );
      })}
    </ScrollableList>
  );
};
